module.exports = __webpack_public_path__ + "static/media/logo_mural_2.53adb9f5.png";